"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.processing.done': 'Zakończone',
    'avatar.processing.is_processing': 'Przetwarzanie',
};
